export function MoveToFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.464 15.9L22 12.364a1 1 0 000-1.414l-3.536-3.536a1 1 0 10-1.414 1.414l1.879 1.88h-3.222v-4a3.001 3.001 0 00-3-3h-8a3 3 0 00-3 3v10a3 3 0 003 3h8a3 3 0 003-3v-4h3.121l-1.778 1.777a1 1 0 001.414 1.415zm-2.757-5.193h-4a1 1 0 100 2h4v-2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
